import { createMemo } from '@packages/react';
import * as React from 'react';
import { PositionedBox, PositionedBoxProps } from './PositionedBox';

export type RelativeProps = PositionedBoxProps;

export const Relative = createMemo<RelativeProps>((props) => <PositionedBox {...props} />, {
    displayName: 'Relative',
    defaultProps: {
        position: 'relative',
    },
});
